module.exports = __webpack_public_path__ + "static/rw-efb3c2344a7cf16c6ea9c7339072e61a.png";